import styled, { css } from 'styled-components';
import Button from '../Button';
export var Picture = /*#__PURE__*/styled.picture.withConfig({
  displayName: "style__Picture",
  componentId: "sc-12s1ihg-0"
})(["display:flex;justify-content:center;align-items:center;width:100%;height:100%;", ";", ";"], function (_ref) {
  var ratio = _ref.ratio;
  return ratio && "padding-bottom: ".concat(1 / ratio * 100, "%;");
}, function (_ref2) {
  var video = _ref2.video;
  return video.src && css([":before{position:absolute;top:0;left:0;display:block;content:'';background:rgba(0,0,0,0.4);width:100%;height:100%;z-index:1;}"]);
});
export var VideoButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "style__VideoButton",
  componentId: "sc-12s1ihg-1"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:2;"]);
export var Iframe = /*#__PURE__*/styled.iframe.withConfig({
  displayName: "style__Iframe",
  componentId: "sc-12s1ihg-2"
})(["width:100%;height:100%;position:absolute;top:0;left:0;z-index:3;"]);